// this file replaces ./fakeApi.ts in the production build
export const stub = undefined
